// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"184f4279","918":"6d282a05"}[chunkId] + ".chunk.js";
};